import { render, staticRenderFns } from "./FinalizeAccount.vue?vue&type=template&id=1c5d76d1&"
import script from "./FinalizeAccount.vue?vue&type=script&lang=js&"
export * from "./FinalizeAccount.vue?vue&type=script&lang=js&"
import style0 from "./FinalizeAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports